import type {MatchParams} from '@wandb/weave/common/types/base';

import type {ContentPart} from '../store/thread';
import {collectAgentPageContext} from './collect';

/**
 * PromptContextParams describes the user's current route scope (entity,
 * project, run) as captured by React Router's URL match. The runtime hook
 * consumes this on every user message to derive the wandb_web_page_state URL.
 */
export type PromptContextParams = MatchParams;

/**
 * buildPromptContextParts produces the wandb-web-page-state content part
 * describing the user's current page (URL, entity/project, and any captured
 * page content) at send time.
 */
export function buildPromptContextParts({
  entityName,
  projectName,
}: PromptContextParams): ContentPart[] {
  const pageContent = collectAgentPageContext();
  const hasProject = !!(entityName && projectName);
  return [
    {
      type: 'wandb-web-page-state',
      content: pageContent.length > 0 ? pageContent : undefined,
      entityName: entityName || undefined,
      projectName: hasProject ? projectName : undefined,
      // NOTE: Drop query/hash to limit prompt-injection and PII leakage.
      url: window.location.origin + window.location.pathname,
    },
  ];
}
